var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstrategia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M197.6,71.8c-1.5-0.9-3.3-1-4.9-0.1l-40.4,22c-1.5,0.8-2.5,2.4-2.5,4.2c0,1.7,0.8,3.4,2.3,4.3l15.2,9.3   c-16.6,21.9-45,26.7-72.5,31.3c-6.1,1-12.4,2.1-18.3,3.3c-33.1,6.8-55.6,20.5-70.6,43.1c-1.5,2.2-0.9,5.3,1.4,6.7   c0.8,0.6,1.8,0.8,2.7,0.8c1.6,0,3.1-0.8,4.1-2.2c13.5-20.3,34-32.7,64.5-39c5.8-1.2,11.7-2.2,17.9-3.2   c28.2-4.7,60.2-10.1,79.1-35.6c0,0,0-0.1,0.1-0.1l15.7,9.6c0.8,0.5,1.7,0.7,2.5,0.7c0.8,0,1.6-0.2,2.3-0.6c1.5-0.8,2.5-2.4,2.5-4.2   l1.1-46C200,74.3,199.1,72.7,197.6,71.8z M189.3,113.4l-24.9-15.2l25.6-14L189.3,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58,91.1c0.9,0,1.8-0.2,2.6-0.8l9.9-6.3l6.3,9.9c0.9,1.5,2.5,2.3,4.1,2.3c0.9,0,1.8-0.2,2.6-0.8c2.3-1.4,2.9-4.4,1.5-6.7   l-6.3-9.9l9.9-6.3c2.3-1.4,2.9-4.4,1.5-6.7c-1.4-2.3-4.4-2.9-6.7-1.5l-9.9,6.3l-6.3-9.9c-1.4-2.3-4.4-2.9-6.7-1.5   c-2.3,1.4-2.9,4.4-1.5,6.7l6.3,9.9l-9.9,6.3c-2.3,1.4-2.9,4.4-1.5,6.7C54.8,90.4,56.4,91.1,58,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M107.1,195.8c-11.8-2.6-23.6,4.8-26.3,16.7c-1.3,5.7-0.3,11.6,2.9,16.6s8,8.4,13.8,9.7c1.6,0.4,3.2,0.5,4.8,0.5   c10.1,0,19.2-7,21.5-17.2c1.3-5.7,0.3-11.6-2.9-16.6S112.8,197.1,107.1,195.8z M114.2,220c-1.5,6.6-8,10.8-14.7,9.3   c-3.2-0.7-5.9-2.6-7.7-5.4c-1.8-2.8-2.3-6.1-1.6-9.2c1.3-5.7,6.4-9.6,12-9.6c0.9,0,1.8,0.1,2.7,0.3c3.2,0.7,5.9,2.6,7.7,5.4   C114.4,213.5,114.9,216.8,114.2,220z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M249.8,18.6c-1.7-2.1-4.7-2.5-6.8-0.8l-37.2,29.5l-13.4-16.7c-1.7-2.1-4.7-2.4-6.8-0.7c-2.1,1.7-2.4,4.7-0.7,6.8l16.4,20.5   c1,1.2,2.4,1.8,3.8,1.8c1.1,0,2.1-0.3,3-1.1l41-32.5C251.1,23.7,251.5,20.7,249.8,18.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrategia);
export default __webpack_public_path__ + "static/media/estrategia.8fdd06de5f98ca032da126c82e164491.svg";
export { ForwardRef as ReactComponent };